import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import classname from 'classnames';

const Props = {
    title: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    classTitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    classChildren: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
};

const SessionSection = ({title, className, classTitle, classChildren, children, stickSectionsToLeft = true}) => {
    const titleClass = classname('font-size-16 session-section-title', {
        'remove-left-margin': stickSectionsToLeft
    }, classTitle);
    const childrenClass = classname(
        {'margin-medium': !stickSectionsToLeft},
        {'margin-bottom-medium margin-right-none margin-left-none': stickSectionsToLeft},
        {'margin-top-medium': !title},
        classChildren
    );

    return (
        <div className={classname('session-section-container', className)}>
            {title &&
                <div className="session-title-container">
                    <div className="title-indicator custom-color color-1-background"/>
                    <div className={titleClass}>{title}</div>
                </div>
            }
            <Row className={childrenClass}>{children}</Row>
        </div>
    );
};

SessionSection.propTypes = Props;
export default SessionSection;
